import { AnyAction, combineReducers } from 'redux';
import { configureStore, getDefaultMiddleware, ThunkDispatch } from '@reduxjs/toolkit';
import { history } from '../appHistory';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import pagetrack from './middlewares/pagetrack';
import { productManagementReducer } from 'modules/ProductManagement';

export const rootReducer = combineReducers({
    productManagement: productManagementReducer,
    router: connectRouter(history),
});

export type RootState = ReturnType<typeof rootReducer>;

const store = configureStore({
    reducer: rootReducer,
    middleware: [...getDefaultMiddleware(), pagetrack, routerMiddleware(history)],
    devTools: process.env.NODE_ENV === 'development',
});

export type AppDispatch = typeof store.dispatch;
export type AppThunkDispatch = ThunkDispatch<RootState, object, AnyAction>;

export default store;
